export default [
  { id: 1, name: 'Januar 2018',             dateFrom: 'Jan 2018',   dateTo: '', transactionAmountSum: 573.40, transactions: [
      {id: 1, name: 'Spotify', transactionAmount: 254.20},
      {id: 2, name: 'Apple Music', transactionAmount: 128.70},
      {id: 3, name: 'Google Play', transactionAmount: 116.10},
      {id: 4, name: 'Deezer', transactionAmount: 104.90},
    ] },
  { id: 2, name: 'Korrektur für Dezeasdasd',dateFrom: '01 Feb 2018',dateTo: '', transactionAmountSum: -306.80,  transactions: [
      {id: 1, name: 'Kutyafüle', transactionAmount: 254.20},
      {id: 2, name: 'Apple Music', transactionAmount: 128.70},
      {id: 3, name: 'Google Play', transactionAmount: 116.10},
      {id: 4, name: 'Deezer', transactionAmount: 104.90},
    ]},
  { id: 3, name: 'Dezember 2017',           dateFrom: 'Jan 2018',   dateTo: 'Feb 2018', transactionAmountSum: 293.20,  transactions: [
      {id: 1, name: 'Macska rúgja meg', transactionAmount: 254.20},
      {id: 2, name: 'Apple Music', transactionAmount: 128.70},
      {id: 3, name: 'Google Play', transactionAmount: 116.10},
      {id: 4, name: 'Deezer', transactionAmount: 104.90},
    ] },
  { id: 4, name: 'November 2017',           dateFrom: 'Feb 2018',   dateTo: '', transactionAmountSum: 107.90,  transactions: [
      {id: 1, name: 'HarapdMegALóLábát', transactionAmount: 254.20},
      {id: 2, name: 'Apple Music', transactionAmount: 128.70},
      {id: 3, name: 'Google Play', transactionAmount: 116.10},
      {id: 4, name: 'Deezer', transactionAmount: 104.90},
    ] },
]
